import { RobotOutlined } from '@ant-design/icons';
import { VerticalSpace } from '@framework/ui';
import { Card, Flex, Space } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const StyledAICard = styled(Card)`
  &.ant-card {
    border-color: ${props => props.theme.colorPrimary};
    border-width: 2px;
    border-radius: 7px;
    transition: all 0.3s ease-in-out;
    .ant-card-head {
      background: ${props => props.theme.colorPrimary};
      color: white;
      min-height: 40px;
      transition: all 0.3s ease-in-out;
    }
    &.disabled {
      border-color: ${props => props.theme.colorBorder};
      .ant-card-head {
        background: ${props => props.theme.colorBorder};
      }
    }
  }
`;

export interface IAiFormCardProps {
  disabled?: boolean;
  title: React.ReactNode;
  children?: React.ReactNode;
}

export function AiFormCard(props: IAiFormCardProps) {
  const { disabled, children, title } = props;
  return (
    <>
      <StyledAICard
        className={clx({ disabled })}
        title={
          <div style={{ fontSize: 24 }}>
            <Space>
              <RobotOutlined />
              <div style={{ fontSize: 18 }}>{title}</div>
            </Space>
          </div>
        }
      >
        <Flex vertical>{children}</Flex>
      </StyledAICard>

      <VerticalSpace />
    </>
  );
}
